module.exports = __webpack_public_path__ + "static/media/companion-img-005.025a177e.jpg";